import {Button, DatePicker, Form, Input, Modal, message} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, {useEffect, useState} from "react";
import api from "../../api";
import dayjs from "dayjs";

export default function EditTaskModal({open, onCancel, onSuccess, task}) {
    const [form] = Form.useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (open && task) {
            form.setFieldsValue({
                title: task.title,
                description: task.description || '',
                due_at: task.due_at ? dayjs(task.due_at) : null
            });
        }
    }, [open, task, form]);

    useEffect(() => {
        if (!open) {
            form.resetFields();
        }
    }, [open, form]);

    function handleSubmit() {
        form.validateFields().then(values => {
            setIsSubmitting(true);
            const taskData = {
                title: values.title,
                description: values.description || null,
                due_at: values.due_at.format('YYYY-MM-DD')
            };
            api.updateTask(task.id, taskData).then(() => {
                message.success('Taak bijgewerkt');
                onSuccess();
                onCancel();
            }).catch(() => {
                message.error('Er ging iets mis');
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={(
                <Button type="primary" onClick={handleSubmit} loading={isSubmitting}>
                    Opslaan
                </Button>
            )}
        >
            <h1>Taak bewerken</h1>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="title"
                    label="Titel"
                    rules={[{required: true, message: 'Vul een titel in'}]}
                >
                    <Input placeholder="Bijv. Onkruid wieden"/>
                </Form.Item>
                <Form.Item name="description" label="Beschrijving">
                    <TextArea
                        autoSize={{minRows: 2, maxRows: 6}}
                        placeholder="Optionele beschrijving..."
                    />
                </Form.Item>
                <Form.Item
                    name="due_at"
                    label="Deadline"
                    rules={[{required: true, message: 'Selecteer een datum'}]}
                >
                    <DatePicker
                        style={{width: '100%'}}
                        format="DD-MM-YYYY"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}
